import React from 'react'

function PageTitle({ pageTitle }) {
  return (
    <div className="page-title">
     <h1>{pageTitle}</h1>
    </div>
  )
}

export default PageTitle